import { useFormContext } from 'react-hook-form';
import { Alert, FormControlLabel, Grid, TextField } from '@mui/material';
import { useRequestDatasetMutation } from '~/api/v2/hooks';
import { MultipleSelect } from '~/components';
import {
  MAX_BUSINESS_VALUE_LENGTH,
  MAX_COST_CENTER_LENGTH,
  MAX_DESCRIPTION_LENGTH,
} from '~/validation/requestAccessSchema';

const useCases = [
  'Product improvement',
  'New product development',
  'General improvement to patient treatment, safety, and quality',
  'Other',
];

const RequestAccessForm = () => {
  const [, { isLoading }] = useRequestDatasetMutation({
    fixedCacheKey: `request-dataset`,
  });
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container spacing={4} p={2}>
      <Grid size={12}>
        <FormControlLabel
          label="COST CENTER"
          required
          control={
            <TextField
              disabled={isLoading}
              placeholder="Enter a cost center"
              {...register('cost_center')}
              error={!!errors.cost_center}
              helperText={errors?.cost_center?.message as string}
              slotProps={{ htmlInput: { maxLength: MAX_COST_CENTER_LENGTH } }}
            />
          }
        />
      </Grid>
      <Grid size={12}>
        <FormControlLabel
          label="DESCRIPTION (WHY DO YOU NEED ACCESS?)"
          required
          control={
            <TextField
              disabled={isLoading}
              placeholder="Enter the description which talks about the business value"
              {...register('use_case_description')}
              multiline
              minRows={3}
              maxRows={6}
              error={!!errors.use_case_description}
              helperText={(errors?.use_case_description?.message as string) || 'Use up to 256 characters'}
              slotProps={{ htmlInput: { maxLength: MAX_DESCRIPTION_LENGTH } }}
            />
          }
        />
      </Grid>
      <Grid size={6}>
        <MultipleSelect
          name="primary_secondary_use_case"
          label="USE CASES"
          options={useCases.map((useCase) => ({
            value: useCase,
            label: useCase,
          }))}
          placeholder="Select the use cases"
          required
          disabled={isLoading}
        />
      </Grid>

      <Grid size={6}>
        <FormControlLabel
          label="BUSINESS VALUE"
          required
          control={
            <TextField
              disabled={isLoading}
              placeholder="Provide the business value"
              {...register('business_value')}
              error={!!errors.business_value}
              helperText={errors?.business_value?.message as string}
              slotProps={{ htmlInput: { maxLength: MAX_BUSINESS_VALUE_LENGTH } }}
            />
          }
        />
      </Grid>
      <Grid size={12}>
        <Alert severity="important">
          Submit a request for access to the Healthcare Data platform and obtain the necessary approval.
        </Alert>
      </Grid>
    </Grid>
  );
};

export default RequestAccessForm;
